import { useState } from 'react';

const Avatar = ({ firstName, lastName, className = '', onClick }) => {
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  
  return (
    <div 
      className={`flex items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white font-medium cursor-pointer ${className}`}
      onClick={onClick}
    >
      {initials || '?'}
    </div>
  );
};

export default Avatar;